import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RuleTranslator } from '@cbridge-packages/rule';
import { PriceFilteringRuleAction } from '../priceFilteringRule.action';
import { PriceFilteringRuleTranslator } from '../priceFilteringRule.translator';

type IDependencies = IClientApiDependencySegment;

export const validatePriceFilteringRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringRuleAction.validate.started),
  switchMap((params) => {
    const rules = params.map(PriceFilteringRuleTranslator.toApi);
    return dependencies.api.validatePriceFilteringRules({ rules }).pipe(
      mergeMap((response) => {
        return [
          PriceFilteringRuleAction.validate.done({ params, result: (response.rules ?? []).map(RuleTranslator.fromApiValidation) }),
        ];
      }),
      catchApiError((error) => {
        return [
          PriceFilteringRuleAction.validate.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
